<!-- templates.component.html -->

<div class="container-templates" >
    <h1 class="title">{{'TEMPLATES' | translate}}</h1>
    <div class="form-card p-4 mb-5">
            <div class="accordion accordion-flush" id="templatesAccordion">

        <!-- Panel 1: Editor de correos -->
        <div class="accordion-item">
            <h2 class="accordion-header " id="headingEmail">
            <button class="accordion-button text-center collapsed" type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelEmail"
                    aria-expanded="false"
                    aria-controls="panelEmail">
                {{'EMAIL_TEMPLATE_EDITOR' | translate}}
            </button>
            </h2>
            <div id="panelEmail"
                class="accordion-collapse collapse"
                aria-labelledby="headingEmail"
                data-bs-parent="#templatesAccordion">
            <div class="accordion-body">
                <app-email-template-editor></app-email-template-editor>
            </div>
            </div>
        </div>

        <!-- Panel 2: Checkout -->
        <div class="accordion-item">
            <h2 class="accordion-header" id="headingCheckout">
            <button class="accordion-button collapsed" type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelCheckout"
                    aria-expanded="false"
                    aria-controls="panelCheckout">
                {{'CHECKOUT_TEMPLATE' | translate}}
            </button>
            </h2>
            <div id="panelCheckout"
                class="accordion-collapse collapse"
                aria-labelledby="headingCheckout"
                data-bs-parent="#templatesAccordion">
            <div class="accordion-body">
                <app-checkout-template-editor></app-checkout-template-editor>
            </div>
            </div>
        </div>

        </div>
    </div>
    

</div>